<template>
	<v-storyblok-nosto :blok="blok" />
</template>

<script setup lang="ts">
import type {BlokComponent} from "@pkg/shared/types";

defineProps<{
	blok: Extract<BlokComponent, {component: "sb-nosto"}>;
}>();
</script>
